function getDanawaWebsite(searchQuery) {
    const searchUrl = `https://www.xerve.in/prices?q=${encodeURIComponent(searchQuery)}`;
    return searchUrl;
}

export default getDanawaWebsite;